module.exports = __webpack_public_path__ + "static/Spa-950eb3624379b84fe5464c3a10a6241a.jpg";